export const ADMIN_COURS_INITIATE_SUPPRIMER_CATEGORIE = 'ADMIN_COURS_INITIATE_SUPPRIMER_CATEGORIE';
export const ADMIN_COURS_SUPPRIMER_CATEGORIE_START = 'ADMIN_COURS_SUPPRIMER_CATEGORIE_START';
export const ADMIN_COURS_SUPPRIMER_CATEGORIE_SUCCESS = 'ADMIN_COURS_SUPPRIMER_CATEGORIE_SUCCESS';
export const ADMIN_COURS_SUPPRIMER_CATEGORIE_FAIL = 'ADMIN_COURS_SUPPRIMER_CATEGORIE_FAIL';
export const ADMIN_COURS_SUPPRIMER_CATEGORIE_RESET = 'ADMIN_COURS_SUPPRIMER_CATEGORIE_RESET';
;